// extracted by mini-css-extract-plugin
module.exports = {"container":"Hukd+d5XQMjMFUEFnApqlg==","logoLink":"sX7VRYlC2Jr3xXTWzYJ7oQ=="};